import { Form, Input } from "antd";
import React from "react";
import type { Rule } from "antd/lib/form";

interface IFormInput {
  label?: string;
  name: string;
  rules?: Rule[];
  className?: string;
  style?: React.CSSProperties;
  placeholder?: string;
  defaultValue?: string | number;
  onChange?: (value: any) => void;
  type?: string;
  maxLength?: number;
  disabled?: boolean;
  addonBefore?: React.ReactNode;
  addonAfter?: React.ReactNode;
  prefix?: React.ReactNode;
  suffix?: React.ReactNode;
  allowClear?: boolean;
  onPressEnter?:(value:any)=>void;
  value?:number | string;
  iconRender?: (visible: boolean) => React.ReactNode;
  onKeyDown?: (e: any) => void;
  autoComplete?: string;
}

const FormInput: React.FC<IFormInput> = (props) => {
  const {
    label,
    name,
    rules = [],
    className,
    style,
    placeholder,
    defaultValue,
    onChange,
    type = "text",
    maxLength,
    disabled = false,
    addonBefore,
    value,
    addonAfter,
    prefix,
    suffix,
    allowClear = false,
    onPressEnter,
    iconRender,
    onKeyDown,
    autoComplete
  } = props;

  return (
    <Form.Item
      label={label}
      name={name}
      rules={rules}
      style={{ margin: "0", ...style }}
    >
      {type === "password" ? (
        <Input.Password
          className={className || "no-border-radius input-height"}
          placeholder={placeholder}
          defaultValue={defaultValue}
          onChange={(e) => onChange && onChange(e.target.value)}
          maxLength={maxLength}
          disabled={disabled}
          iconRender={iconRender}
          autoComplete={autoComplete}
        />
      ) : (
        <Input
          className={className || "no-border-radius input-height"}
          placeholder={placeholder}
          defaultValue={defaultValue}
          value={value}
          onChange={(e) => onChange && onChange(e.target.value)}
          type={type}
          maxLength={maxLength}
          disabled={disabled}
          addonBefore={addonBefore}
          addonAfter={addonAfter}
          prefix={prefix}
          onPressEnter={onPressEnter}
          suffix={suffix}
          allowClear={allowClear}
          onKeyDown={onKeyDown}
        />
      )}
    </Form.Item>
  );
};

export default FormInput;
